import { RevInput } from "@revmatics/catalyst";
import { useFormContext } from "react-hook-form";
import { CreateCompanyFormDataType } from "../../../../stores/types/companyTypes.tsx";

export const StepCompanyAdmin = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CreateCompanyFormDataType>();
  return (
    <div>
      <p className="typography-body-bold-sm">Company Admin</p>
      <p className="typography-body-xs text-monochrome-600">
        The primary administrator for this company.
      </p>
      <div className="mt-4 mb-1 space-y-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <RevInput
            name="first_name"
            className="w-full"
            label="First Name"
            placeholder=""
            type="text"
            size="md"
            required
            register={register("first_name", {
              required: "First name is required.",
            })}
            error={errors.first_name}
          />
          <RevInput
            name="last_name"
            className="w-full"
            label="Last Name"
            placeholder=""
            type="text"
            size="md"
            required
            register={register("last_name", {
              required: "Last name is required.",
            })}
            error={errors.last_name}
          />
        </div>
        <div>
          <RevInput
            name="email"
            className="w-full"
            label="Company Admin Email"
            type="text"
            size="md"
            required
            register={register("email", {
              required: "Company admin email is required.",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
            error={errors.email}
          />
        </div>
      </div>
      <p className="typography-body-xs text-monochrome-600">
        The admin user will need to set up their password through the
        authentication system.
      </p>
    </div>
  );
};
